import angular from 'angular';
import teamCalendarListCardDetailComponent from './teamCalendarListCardDetail.component';

let teamCalendarListCardDetailModule = angular.module('teamCalendarListCardDetail', [])

  .component('teamCalendarListCardDetail', teamCalendarListCardDetailComponent)

  .name;

export default teamCalendarListCardDetailModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamCalendarMobile/teamCalendarList/teamCalendarListCard/teamCalendarListCardDetail/teamCalendarListCardDetail.js